import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from '../Login/Login.module.css';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 1rem;
`;

const Content = styled.div`
  text-align: center;
  max-width: 500px;
  width: 100%;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 480px) {
    padding: 1.5rem;
    margin: 0 1rem;
  }
`;

const Title = styled.h2`
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.75rem;
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Message = styled.p`
  margin: 1.5rem 0;
  font-size: 1rem;
  color: #555;
  line-height: 1.5;
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
    margin: 1.25rem 0;
  }
`;

const IconWrapper = styled.div`
  margin: 1.5rem 0;
  
  svg {
    width: 4rem;
    height: 4rem;
    
    @media (max-width: 480px) {
      width: 3.5rem;
      height: 3.5rem;
    }
  }
`;

const ExpiredPass = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Content>
        <Title>Pass Expired</Title>
        <IconWrapper>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="#dc3545" 
            className="bi bi-exclamation-triangle" 
            viewBox="0 0 16 16"
          >
            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
          </svg>
        </IconWrapper>
        <Message>
          This pass is no longer valid as it has expired. Please contact the administrator if you believe this is an error.
        </Message>
      </Content>
    </Container>
  );
};

export default ExpiredPass;
